module.exports = __webpack_public_path__ + "media/headerbg.d1fdad00.mp4";